import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resource-utilization',
  templateUrl: './resource-utilization.component.html',
  styleUrls: ['./resource-utilization.component.scss']
})
export class ResourceUtilizationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
